/* eslint-disable */

import { StyleSheet } from 'aphrodite'
import React, { useState } from 'react'
import { useLoad } from "../../hooks/request";
import { useQueryParams } from "../../hooks/queryString";
import Button from "../../components/common/Button";
import { useModal } from "../../hooks/modal";
import Layout from "../../components/Layout";
import { ENTRANCE_LIST } from "../../urls";
import EntranceCreate from "./EntranceCreate";
import Table from "../../components/common/Table";
import EntranceItem from "./EntranceItem";
import BuildingTabs from "../../components/BuildingTabs";
import { useParams } from "react-router-dom";


export default function Entrance() {
    const { buildId } = useParams()
    const [page, setPage] = useState(1)
    const [params, setParams] = useState({})

    const searchParam = useQueryParams()
    const entrance = useLoad({
        url: ENTRANCE_LIST,
        params: { page, ...params, ...searchParam }
    }, [searchParam, page, params])

    const productList = entrance.response ? entrance.response.results : []
    const [showCreateModal, setShowCreateModal] = useModal(<EntranceCreate buildId={buildId} expenseReport={entrance}
                                                                           onCancel={() => setShowCreateModal()}/>, styles.modal)

    return (
        <Layout showCreateModal={showCreateModal}>
            <div className="is-flex is-justify-content-space-between mb-3 is-align-items-center">
                <h2 className="title is-size-4">Падездлар</h2>
                <Button text="Қўшиш" className="button is-link is-outlined" onClick={showCreateModal}/>
            </div>
            <BuildingTabs/>


            <div>

                <div className="mt-4 mb-4">
                    <Table
                        loading={entrance.loading}
                        items={productList}
                        columns={{
                            index: '№',
                            datae: 'Дом',
                            date: 'Падезд',
                            buttons: ''
                        }}
                        totalCount={entrance.response ? entrance.response.count : 0}
                        activePage={page}
                        onPageChange={setPage}
                        renderItem={(item, index) => <EntranceItem entrance={entrance} index={index} key={item.id}
                                                                   item={item}/>}
                    />

                </div>
            </div>
        </Layout>
    )
}

const styles = StyleSheet.create({
    space: { marginTop: '2rem' },
    emptyImg: { width: '330px', height: '300px' },
    loader: { marginTop: '2rem' },
    modal: { width: 800 },
    checkmark: { marginRight: '3px' },
})
